// src/common/components/serviceOtpContent/ServiceOtpContent.tsx
import React from "react";
import QRCode from "react-qr-code";
import { useTheme } from "../../hooks/useTheme";
import { useServiceOtp } from "./useServiceOtp";
import { useSelector } from "react-redux";
import { selectIsOnline } from "../../../store/slices/networkSlice";
import styles from "./ServiceOtpContent.module.scss";
import Loader from "../loader/Loader";

export const ServiceOtpContent: React.FC = () => {
  const { theme } = useTheme();
  const isOnline = useSelector(selectIsOnline);
  const { otpData, loading, nextCode, refreshOtp } = useServiceOtp();

  if (loading) {
    return (
      <div className={styles.center}>
        <Loader />
      </div>
    );
  }

  if (!otpData || otpData.codes.length === 0) {
    return (
      <div className={styles.center}>
        <p className={styles.text} style={{ color: theme.text }}>
          Коды закончились
        </p>
        <button
          className={styles.refreshButton}
          onClick={refreshOtp}
          disabled={!isOnline}
        >
          {isOnline ? "Обновить" : "Нужен интернет"}
        </button>
      </div>
    );
  }

  const currentCode = otpData.codes[0];
  const isLastCode = otpData.codes.length === 1;

  return (
    <div className={styles.container}>
      <div className={styles.qrWrapper}>
        <QRCode value={currentCode} size={200} />
      </div>
      <p className={styles.code} style={{ color: theme.text }}>
        {currentCode}
      </p>
      <button
        className={styles.refreshButton}
        onClick={nextCode}
        disabled={isLastCode && !isOnline}
      >
        {isLastCode && !isOnline ? "Нет сети" : "Обновить код"}
      </button>
    </div>
  );
};
